export default class DatePickerConfig {
  selectedDate;
  initialDate;
  color;
  type;
  min;
  max;
  range;
  constructor(data) {
    this.mountData(data);
  }
  mountData(data) {
    if (data) Object.assign(this, data);
  }
}
